import { render, staticRenderFns } from "./CopyLayoutBudgets.vue?vue&type=template&id=066ece91"
import script from "./CopyLayoutBudgets.vue?vue&type=script&lang=ts"
export * from "./CopyLayoutBudgets.vue?vue&type=script&lang=ts"
import style0 from "./CopyLayoutBudgets.vue?vue&type=style&index=0&id=066ece91&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports